module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gtmAI"))).then(() => parcelRequire('9Lwss'));